import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { DateRangeInput } from '@blueprintjs/datetime';
import moment from 'moment';
import MomentLocaleUtils from 'react-day-picker/moment';
import 'moment/locale/vi';
import Clearfix from 'components/elements/clearfix';

const ElementWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const MAX_DATE = 20;

export default class DateRangeInputElement extends React.PureComponent {
  static propTypes = {
    onChange: PropTypes.func,
  };

  handleOnChange = (values) => {
    if (this.props.onChange) {
      if (values[0] && values[1]) {
        this.props.onChange(values);
      } else {
        const { isSearch } = this.props;
        if (isSearch) {
          this.props.onChange(values);
        } else {
          this.props.onChange(undefined);
        }
      }
    }
  };
  render() {
    const { label, ...otherProps } = this.props;
    return (
      <ElementWrapper>
        {this.props.label && (
          <React.Fragment>
            <span>{this.props.label}</span>
            <Clearfix width={8} />
          </React.Fragment>
        )}
        <div style={{ flex: 1 }}>
          <DateRangeInput
            locale='vi'
            localeUtils={MomentLocaleUtils}
            maxDate={moment().add(MAX_DATE, 'year').toDate()}
            {...otherProps}
            onChange={this.handleOnChange}
          />
        </div>
      </ElementWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/elements/date-range-input/index.js